import { render, staticRenderFns } from "./NameCard.vue?vue&type=template&id=16df3fe8&scoped=true&"
import script from "./NameCard.vue?vue&type=script&lang=js&"
export * from "./NameCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df3fe8",
  null
  
)

export default component.exports